exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".big_icon_com_mo .img-format{width:40px;margin:0 auto;border-radius:50%;overflow:hidden}.big_icon_com_mo .img-format img{max-width:100%!important;width:auto!important;border-radius:0!important;height:40px}.icon_com_mo .icon-div{width:16px;margin:0 auto;border-radius:50%;overflow:hidden}.icon_com_mo .icon-div img{height:16px;max-width:100%}@media only screen and (min-device-width:375px) and (max-device-width:812px){.icon_com_mo{padding:0;margin-left:5px}.big_icon_com_mo{padding:2px}.text_com_mo{margin-left:-15px;font-size:11px}.row_com_mo{margin-top:5px}}.img_com{border-radius:50%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fe902aa6","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/CommunityItem.vue
// module id = 1182
// module chunks = 0